import { useState, useEffect } from 'react'
import { useChartStore } from 'Store/chart'
import moment from 'moment'

const ViewModel = () => {
  const INITIAL_START_DATE = moment()
    .tz('Asia/Bangkok')
    .subtract(3, 'months')
    .startOf('month')
    .toDate()
  const INITIAL_END_DATE = moment().tz('Asia/Bangkok').toDate()

  const [startDate, setStartDate] = useState<Date>(INITIAL_START_DATE)
  const [endDate, setEndDate] = useState<Date>(INITIAL_END_DATE)
  const [dataType, setDataType] = useState<'month' | 'daily'>('month')
  const dataTypeOptions = [
    { label: 'รายเดือน', value: 'month' },
    { label: 'รายวัน', value: 'daily' },
  ]

  const {
    projectStat,
    projectPileStat,
    projectPileHolesUpdateThisWeek,
    getProjectStats,
    getProjectPileStats,
    getProjectPileHolesUpdateThisWeek,
  } = useChartStore(state => ({
    projectStat: state.projectStat,
    projectPileStat: state.projectPileStat,
    projectPileHolesUpdateThisWeek: state.projectPileHolesUpdateThisWeek,
    getProjectStats: state.getProjectStats,
    getProjectPileStats: state.getProjectPileStats,
    getProjectPileHolesUpdateThisWeek: state.getProjectPileHolesUpdateThisWeek,
  }))

  const statBoxes = [
    {
      img: '/media/icons/total-project.svg',
      number: projectStat?.totalProjects ?? 0,
      title: 'ทั้งหมด',
      percentage: 0,
    },
    {
      img: '/media/icons/total-completed.svg',
      number: projectStat?.completedProjects ?? 0,
      title: 'เสร็จสิ้น',
      percentage: 0,
    },
    {
      img: '/media/icons/total-canceled.svg',
      number: projectStat?.inProgressProjects ?? 0,
      title: 'กำลังดำเนินการ',
      percentage: 0,
    },
    {
      img: '/media/icons/total-in-progress.svg',
      number: projectStat?.pendingProjects ?? 0,
      title: 'รอเปิดงาน',
      percentage: 0,
    },
  ]

  const fetchData = async () => {
    getProjectStats()
    getProjectPileStats()
    getProjectPileHolesUpdateThisWeek()
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { statBoxes, projectPileStat, projectPileHolesUpdateThisWeek }
}

export default ViewModel
